import { Dispatch, SetStateAction } from 'react';
import { Switch } from '@headlessui/react';

type ToggleProps = {
    enabled: boolean;
    setEnabled: Dispatch<SetStateAction<boolean>>;
    label?: string;
    id?: string;
};

const Toggle = ({ enabled, setEnabled, label, id }: ToggleProps) => {
    return (
        <Switch.Group>
            <div className='flex flex-row gap-x-1 items-center cursor-pointer'>
                <Switch
                    id={id}
                    checked={enabled}
                    onChange={setEnabled}
                    className={`${enabled ? 'bg-primary-500' : 'bg-gray-300'} relative inline-flex h-5 w-9 items-center rounded-full outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400 focus-visible:ring-offset-2`}
                >
                    <span
                        aria-hidden="true"
                        className={`${
                            enabled ? 'translate-x-5' : 'translate-x-1'
                        } inline-block h-3 w-3 transform rounded-full bg-white transition`}
                    />
                </Switch>
                {label && (
                    <Switch.Label className={`font-semibold ${!enabled ? 'opacity-50' : 'text-primary-700'}`}>
                        {label}
                    </Switch.Label>
                )}
            </div>
        </Switch.Group>
    );
};
export default Toggle;
